import { ImageResource } from '@tencent/alloy-renderer';
import { generateFailImageUrl } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-graphic/fill-style/image-cache/fail-image';
import { imageCache } from '@tencent/alloy-graphics';

export function createImageSource(text: string, width: number, height: number) {
    return new ImageResource(new Promise((resolve) => {
        const img = new window.Image();
        img.onload = () => resolve(img);
        img.src = generateFailImageUrl(text, width, height);
    }));
}

export function createImageSourceWithSrc(src: string) {
    // 图片需要通过imageCache，因为如果是svg图片，会出现污染canvas，导致toBlob失败，影响显示
    return imageCache.get({ alloyParams: { urlOrImage: src } });
}
